import React, { useState } from 'react';
import {LeadFilterModel, LeadModel, SPLeadModel,SimulatorOfferModel,TreatmentModel} from './models/superbit-api-models'
import { StatOptions } from 'fs';
import moment from 'moment';
import LeadOffer from './leads/_LeadOffer'
import { LeadTreatment } from './_LeadTreatment'
import { LinkToSimulator } from './leads/_LinkToSimulator';
import { LeadsModel } from './models/LeadsModel';
import {OfferProductionModel} from './models/OfferProductionModel'
import OfferProduction from './production/_OfferProduction'
import LeadTreatments from './leads/_LeadTreatments';
import { setPhoneNumberOfLead } from './app-context/leadsSlice';
import { connect } from 'react-redux';
import { RootState } from './app-context/store';
import { set } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFire } from '@fortawesome/free-solid-svg-icons';

type Props = {
    lead: SPLeadModel | null;
    open: boolean;
    closeLead: any;
    onMenuClick: any;
    getAuthorizedToDriveName:any;
    openPopupMessage?: Function;
    simulatorPermission: boolean;
    isAdmin: boolean | undefined;
    phoneNumberOfLead: string;
    setPhoneNumberOfLead: (data: string) => void;

};

type State = {
    showBtnOptions: boolean;
    lead: LeadModel;
    level?:number;
    leadData: SPLeadModel
    leadTopTypeLabel: string;
    leadAdditionsString: string;
    offerSortBy: any;
    offersList: any[];
    productionOffer: SimulatorOfferModel | null;
    OpenProduction:string|null;
};


class OpenLead extends React.Component<Props, State> {
    leadsModel: LeadsModel = new LeadsModel();
    OfferProductionModel:OfferProductionModel = new OfferProductionModel();
    emptyId = '00000000-0000-0000-0000-000000000000';
    constructor(props: any) {
        super(props);
        const leadTopTypes: string[] = [
            'רכב',
            'דירה/עסק',
            'אחר'
        ];
        let leadTopTypeLabel = leadTopTypes[0];
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.leadTopType && this.props.lead.lead.leadTopType > 0) {
            leadTopTypeLabel = leadTopTypes[this.props.lead.lead.leadTopType];
        }

        const sortedTreatments = props.lead?.lead?.treatments
            ? [...props.lead.lead.treatments].sort((a: any, b: any) => b.eventDate - a.eventDate)
            : undefined;

        const offersList: any[] = this.props.lead?.offers ? [...this.props.lead.offers] : [];
        offersList.sort((a: any, b: any) => a.offerIdentity - b.offerIdentity)
        this.state = {
            showBtnOptions: false,
            lead: {
                ...props.lead.lead,
                treatments: sortedTreatments ?? props.lead.lead.treatments
            },
            leadData: props.lead,
            leadTopTypeLabel: leadTopTypeLabel,
            leadAdditionsString: this.props.lead && this.props.lead.lead && this.props.lead.lead.leadAdditionsFromRelation ? this.buildLeadAdditionsString(this.props.lead.lead.leadAdditionsFromRelation) : '',
            offerSortBy: {
                column: 'offerIdentity',
                direction: 'ASC'
            },
            offersList: offersList,
            productionOffer: null,
            OpenProduction:null  
        }

        this.init(); 
    }

    async init(){

        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.id) {
            var OpenProductionByLead  =await new OfferProductionModel().getOpenProductionByLead(this.props.lead.lead.id);
            await this.setState({ OpenProduction: OpenProductionByLead ?OpenProductionByLead:""});
            
        }
        
    }

    buildOffersList() {
        
        if (this.state.lead != null && this.state.lead != null && this.state.lead != null && this.state.lead.offers != null) {
            const offersList: any[] = this.state.lead.offers;
            // offersList.sort((a: any, b:any) => a.offerIdentity - b.offerIdentity);
            // offers.sort((a: any, b:any) => {
            //     return offersSort.direction == 'ASC' ? a[columnName] - b[columnName] : b[columnName] - a[columnName];
            // });
            this.setState({
                offersList: offersList
            });
        }


    }

    buildLeadAdditionsString(leadAdditionsFromRelation: any[]): string {
        let returnStr: string = '';
        leadAdditionsFromRelation.map((item) => {
            if (returnStr !== '') {
                returnStr += ', ';
            }
            returnStr += item.name;
        })
        return returnStr;
    }

    toggleBtnMenu() {
        const curentState = this.state.showBtnOptions;
        this.setState({
            showBtnOptions: !curentState
        })
    }
    onSimulatorClick = () => {
        if (this.state.lead && this.state.lead.id) {
            //console.log('Lead to Simulator', this.state.lead.id)
        }
    }
    onMenuClick(action: string, value?: string) {
        this.props.onMenuClick(action);
        this.toggleBtnMenu()
    }

    componentDidMount() {

        setTimeout(() => {
            
                
                if(this.props.lead && this.props.lead.lead && this.props.lead.lead.phoneNumber1) {
                    this.initPhoneNumberOfLead(this.props.lead.lead.phoneNumber1);
                }
            
        },100);
        


        moment.locale('he');
        this.sortOffers();
    }

    initPhoneNumberOfLead(phoneNumber: string) {
        setTimeout(() => {
            console.log('OpenLead', phoneNumber);
            this.props.setPhoneNumberOfLead(phoneNumber);
        }, 100);
        
    }

    closeLead(e: any) {
        if (e.target.className == 'act-btn-icon icon menu-hamburger pointer' ||
            e.target.className == 'action-btn-menu-item pointer' ||
            e.target.className == 'description cell-value phone-number' ||
            e.target.parentElement.className == 'cell car-details'
        ) return;
        this.props.closeLead();
    }

    onRefreshData() {
        if (this.state.lead != null && this.state.lead.id) {
            const leadId = this.state.lead.id.toString();
            const f: LeadFilterModel = new LeadFilterModel();
            f.LeadId = leadId;
            this.leadsModel.filter(f).then((res) => {
                const lead = this.state.lead;
                const offers = res.leads?.[0]?.lead?.offers ? [...res.leads[0].lead.offers] : [];
                const treatments = res.leads?.[0]?.lead?.treatments ? [...res.leads[0].lead.treatments] : [];
                const sortedTreatments = treatments.sort((a: any, b: any) => b.eventDate - a.eventDate);
                const updatedLead = {
                    ...lead,
                    offers,
                    treatments: sortedTreatments
                };
                this.setState({
                    lead: updatedLead as any ,
                    level:res.level
                })
                //console.log(res);
                this.sortOffers();
            });
        }
    }

    openPopupMessage(d: any) {
        if (this.props.openPopupMessage) {
            this.props.openPopupMessage(d);
        }
    }

    onOfferSortClick(columnName : string) {
        //console.log('onOfferSortClick');
        const offersSort = this.state.offerSortBy;
        if (columnName == offersSort.column) {
            offersSort.direction = offersSort.direction == 'ASC' ? 'DESC' : 'ASC';
        } else {
            offersSort.direction = 'ASC';
            offersSort.column = columnName;
        }
        if (this.state.lead != null && this.state.lead != null && this.state.lead.offers != null) {
            const lead = this.state.lead;
            const offers = [...this.state.lead.offers];

            const sortedOffers = offers.sort((a: any, b: any) => {
                return offersSort.direction == 'ASC' ? a[columnName] - b[columnName] : b[columnName] - a[columnName];
            });
            const updatedLead: any = {
                ...lead,
                offers: sortedOffers
            };
            this.setState({
                offerSortBy: offersSort,
                lead: updatedLead
            }, () => this.sortOffers());
        }
    }

    sortOffers() {
        const lead = this.state.lead;
        if (lead) {
            const offers = this.state.lead.offers;
            const offersSort = this.state.offerSortBy;
            if (offers) {
                const sortedOffers = [...offers].sort((a: any, b: any) => {
                    return offersSort.direction == 'ASC' ? a[offersSort.column] - b[offersSort.column] : b[offersSort.column] - a[offersSort.column];
                });

                const updatedLead: any = {
                    ...lead,
                    offers: sortedOffers
                };
                this.setState({
                    lead: updatedLead
                }, () => this.buildOffersList());
            }

        }
    }

    checkPermissionsOfCreator() {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
          loggedUser = JSON.parse(loggedUser);
          let moodelPermision = loggedUser.menuPermissions.find((p: any) => p.moduleName == 'Leads');
    
          if (moodelPermision && moodelPermision.permissionType == 2) {
            return true;
          }
        }
        return false;
      }
        
    render() {
        let vehicle = null;
        if (this.state.lead != null && this.state.lead != null) {
            vehicle = this.state.lead.vehicle;
            //console.log('vehicle', vehicle)
        }



        return (
            <>
                {/* {
                    this.state.productionOffer && <OfferProduction offer={this.state.productionOffer} closeProduction={this.closeProduction} />
                } */}
                <div>
                    {this.state.lead != null ? (
                        <div className={this.props.open ? "data-card-row opened" : "hide"} >
                            <div className="data-card flex-space-between">
                                <div className="data-card-body flex-space-between" onClick={(e: any) => this.closeLead(e)}>
                                    <div className="cell icon-cell desktop-only">
                                        {this.state.level != null && this.state.level ==1?<div className="icon tag"></div>:""}
                                        {this.state.level != null && this.state.level ==2?<><FontAwesomeIcon icon={faFire} />4</>:""}
                                        {this.state.level != null && this.state.level ==3?<><FontAwesomeIcon icon={faFire} />5</>:""}
                                    </div>
                                    <div className="cell short">
                                        <div className="title">סטטוס</div>
                                        <div className="flex-end">
                                            <div className="status flex-centered flex-space-between">
                                                <div className="status-circle"></div>
                                                <div className="sub-title">{this.state.leadData.lastStatusName}</div>
                                                <div className="qty">
                                                    <div className={this.state.lead.doubleLead ? "qty-circle" : "hide"}></div>
                                                    <div className={this.state.lead.doubleLead ? "qty-number flex-centered flex-justify-center" : "hide"}>x2</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cell desktop-only">
                                        <div className="description cell-value">
                                            {moment(this.state.lead.createdDate).format('DD-MM-YYYY')}
                                        </div>
                                        <div className="description">
                                            {(moment(this.state.lead.createdDate)).format('HH:mm')}
                                        </div>
                                    </div>
                                    <div className="cell long">
                                        <div className="title">סניף</div>
                                        <div className="description cell-value">
                                            {this.state.leadData.branchesPath}
                                        </div>
                                    </div>
                                    <div className="cell">
                                        <div className="title">עמדה</div>
                                        <div className="description cell-value">
                                            {this.state.lead.stationUser != null ? this.state.lead.stationUser.fullName : ""}
                                        </div>
                                    </div>
                                    <div className="cell">
                                        <div className="title">מטפל</div>
                                        <div className="description cell-value">
                                            {this.state.lead.handler != null ? this.state.lead.handler.fullName : ""}
                                        </div>
                                    </div>
                                    <div className="cell">
                                        <div className="title">איש קשר</div>
                                        <div className="description cell-value">
                                            {this.state.lead != null ? this.state.lead.firstName + " " + this.state.lead.lastName : ""}
                                        </div>
                                    </div>
                                    <div className="cell">
                                        <div className="title">טלפון</div>
                                        <div className="description cell-value phone-number">
                                            {this.state.lead.phoneNumber1}
                                        </div>
                                    </div>
                                    <div className="cell">
                                        <div className={vehicle != null && typeof vehicle.carLicenseFilePath != 'undefined' && vehicle.carLicenseFilePath ? "icon paperclip" : ""}  ></div>
                                    </div>
                                    <div className="cell car-details">
                                        <div className="title">רכב</div>
                                        <div className="sub-title">{vehicle != null && vehicle.vehicleSubModel != null ? vehicle.vehicleSubModel.modelCode : ""}</div>
                                        <div className="description">{vehicle != null && vehicle.vehicleSubModel != null ? vehicle.vehicleSubModel.name + ' ' + vehicle.licenseNumber : ""}</div>
                                    </div>
                                    <div className="cell car-details">
                                        <div className="title">
                                            סוג ליד
                                        </div>
                                        <div className="description">
                                            {this.state.leadTopTypeLabel}
                                        </div>
                                    </div>
                                    <div className="cell car-details">
                                        <div className="title">שנה</div>
                                        <div className="sub-title">{vehicle != null && vehicle.vehicleSubModel != null ? vehicle.carYear : ""}</div>

                                    </div>
                                    <div className="cell notes long">
                                        <div className="title">
                                            הערות
                                        </div>
                                        <div className="description cell-value">
                                            {this.state.lead.internalComment}
                                        </div>
                                    </div>
                                    <div className="cell desktop-only">
                                        <div className="description cell-value">
                                            {moment(this.state.lead.deliveryDate).format('DD-MM-YYYY')}
                                        </div>
                                    </div>
                                    <div className="cell button-cell desktop-only">
                                        {/* <button className="act-btn"
                        onClick={()=>{this.toggleBtnMenu()}}
                    >
                        פעולות
                    </button> */}
                    <div className='act-btn-icon icon menu-hamburger pointer'
                        onClick={()=>{this.toggleBtnMenu()}}></div>
                    {this.state.showBtnOptions && (
                            <ul className="btn-menu">
                                {this.checkPermissionsOfCreator() ? (
                                    <li className="action-btn-menu-item pointer"
                                        onClick={()=>{this.onMenuClick('edit')}}
                                    >
                                        ערוך
                                    </li>
                                ) : (<></>)}
                                {this.props.isAdmin ? (
                                <li className="action-btn-menu-item pointer">
                                    מחק 
                                </li>
                                                ):(<></>)}
                                <li className="action-btn-menu-item pointer">
                                    הדפס 
                                </li>
                                {/* <li className="action-btn-menu-item pointer"
                                    onClick={()=>{this.onMenuClick('simulator')}}
                                >
                                    סימולטור
                                </li> */}
                                {this.props.simulatorPermission && this.state.leadData && this.state.lead && this.state.lead.id && this.state.lead.leadTopType == 0 &&  ((this.state.lead.vehicleId && this.state.lead.vehicleId !== this.emptyId) || this.state.lead.vehicle && this.state.lead.vehicle.id && this.state.lead.vehicle.id !== this.emptyId)  && (
                                                                                                                                                                                                                                                                 
                                        <LinkToSimulator
                                            onClick={()=>{this.onSimulatorClick()}}
                                            leadId={this.state.lead.id}
                                        ></LinkToSimulator>
                                    )
                                }
                            </ul>
                            )}
                </div>
                <div className="action pointer">
                    <div className="icon left-arrow toggle-leed" onClick={(e:any)=>this.closeLead(e)}></div>
                </div>
                </div>
                <div className="bottom-row flex-space-between flex-centered">
                    <div className="bottom-actions flex-space-between flex-centered">
                        <div className="icon tag"></div>
                        <div className="license flex-space-between flex-centered">
                            <div className="icon paperclip"></div>
                            <div>רישיון</div>
                        </div>
                    </div>
                    <div>
                        <button className="act-btn">פעולות</button>
                    </div>
                </div>
            </div>
            <div className="data-card-details">
                <div className="details-row">
                    <div className="row-title">רכב</div>
                    <div className="lead-main-details flex-space-between">
                        <div className="car-info">
                            <div className="title">
                                שנה
                            </div>
                            <div>
                            {vehicle!=null && vehicle.vehicleSubModel!=null ? vehicle.carYear:"&nbsp;"}
                            </div>
                        </div>
                        <div className="car-info">
                            <div className="title">
                                קוד דגם
                            </div>
                            <div>
                            {vehicle!=null && vehicle!=null && vehicle.vehicleSubModel && vehicle.vehicleSubModel.modelCode != '' ? vehicle.vehicleSubModel.modelCode :(
                                <>
                                &nbsp;
                                </>
                            )}
                            </div>
                        </div>
                        <div className="car-info">
                            <div className="title">
                                מ. רישוי
                            </div>
                            <div>
                                {vehicle!=null && vehicle.licenseNumber!=null && vehicle.licenseNumber!='' ? vehicle.licenseNumber: (
                                    <>
                                    &nbsp;
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="car-info no-overflow lead-additions">
                            <div className="title">
                                מיגון
                            </div>
                            <div title={this.state.leadAdditionsString}>
                                 {this.state.leadAdditionsString}
                                {/* {this.state.lead!=null && this.state.lead.leadAdditionsFromRelation ? 
                                    this.state.lead.leadAdditionsFromRelation.map((item)=>(<span>
                                        {item.name}
                                    </span>)) 
                                    : 
                                    (<span>
                                        &nbsp;
                                    </span>)
                                } */}
                            &nbsp;
                            </div>
                        </div>
                        <div className="car-info">
                            <div className="title">
                                יצרן
                            </div>
                            <div>
                            {vehicle!=null && vehicle.manufacturer!=null ? vehicle.manufacturer.name :
                            <>
                                &nbsp;
                            </>}
                            </div>
                        </div>
                        <div className="car-info">
                            <div className="title">
                                דגם
                            </div>
                            <div>
                            {vehicle!=null && vehicle.vehicleModel!=null ? vehicle.vehicleModel.name:""}
                            </div>
                        </div>
                        <div className="car-info">
                            <div className="title">
                                תת דגם
                            </div>
                            <div>
                            {vehicle!=null && vehicle.vehicleSubModel!=null ? vehicle.vehicleSubModel.name:""}
                            </div>
                        </div>
                        <div className="car-info">
                            <div className="title">
                                ת. מסירה
                            </div>
                            <div>
                            {moment(this.state.lead.deliveryDate).format('DD-MM-YYYY')}                            
                            </div>
                        </div>
                    </div>
                    <div className="flex-space-between flex-centered flex-top">
                        <div className="cell car-info">
                            &nbsp;
                        </div>
                        <div className='cell long lead-comment'>
                            <div className="titleRowEdit ">
                                הערת המפנה
                            </div>
                            <div className="comments">
                                {this.state.lead.comment}
                            </div>
                        </div>
                        <div className="cell">
                            &nbsp;
                        </div>
                        <div className='cell long lead-comment'>
                            <div className="titleRowEdit ">
                                הערה פנימית
                            </div>
                            <div className="comments">
                                {this.state.lead.internalComment}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="details-row no-padding offers">
                    <div className="row-title">
                        הצעות
                    </div>
                    <div id="offersTbl" className="content-table-header flex-centered flex-space-between">
                        <div className="cell status pointer" onClick={()=>this.onOfferSortClick('offerIdentity')}>
                            מס'
                            {
                                this.state.offerSortBy.column == 'offerIdentity' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'offerIdentity' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div>
                        <div className="cell date flex-centered flex-space-between pointer" onClick={()=>this.onOfferSortClick('startDate')} style={{minWidth: 140, width: 140}}>
                            תאריכים
                            {
                                this.state.offerSortBy.column == 'startDate' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'startDate' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div>
                        {/* <div className="cell date flex-centered flex-space-between pointer" onClick={()=>this.onOfferSortClick('endDate')}>
                            ת. תחילה
                            {
                                this.state.offerSortBy.column == 'endDate' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'endDate' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div>
                        <div className="cell date flex-centered flex-space-between pointer" onClick={()=>this.onOfferSortClick('createdDate')}>
                            ת. סיום
                            {
                                this.state.offerSortBy.column == 'createdDate' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'createdDate' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div> */}
                        <div className="cell pointer" onClick={()=>this.onOfferSortClick('driverMainAge')} style={{width: 90}}>
                            נהגים
                            {/* {
                                this.state.offerSortBy.column == 'driverMainAge' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'driverMainAge' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            } */}
                        </div>
                        {/* <div className="cell pointer" onClick={()=>this.onOfferSortClick('driverYoungAge')}>
                            גיל/ותק צעיר
                            {
                                this.state.offerSortBy.column == 'driverYoungAge' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'driverYoungAge' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div> */}
                        <div style={{width: 80, paddingBottom: '20px'}} onClick={()=>this.onOfferSortClick('driverYoungAge')}>
                            מספר נהגים
                            {
                                this.state.offerSortBy.column == 'driverYoungAge' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'driverYoungAge' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div>
                        <div className="cell wide pointer" onClick={()=>this.onOfferSortClick('vehicleSubModel')}>
                          הנכס
                            {
                                this.state.offerSortBy.column == 'vehicleSubModel' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'vehicleSubModel' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div>
                        <div style={{width: 80, paddingBottom: '20px'}} onClick={()=>this.onOfferSortClick('insuranceCompany')}>
                            חברה 
                            {
                                this.state.offerSortBy.column == 'insuranceCompany' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'insuranceCompany' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div>
                        <div style={{width: 80, paddingBottom: '20px'}} onClick={()=>this.onOfferSortClick('insuranceType')}>
                            עבר ביטוחי
                            {
                                this.state.offerSortBy.column == 'insuranceType' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'insuranceType' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div>
                        <div style={{width: 80, paddingBottom: '20px'}} >
                            פרטים
                        </div>
                        <div style={{width: 80, paddingBottom: '20px'}} >
                            סעיפים
                        </div>
                        {/* <div className="cell pointer" onClick={()=>this.onOfferSortClick('routeId')}>
                            ענף 
                            {
                                this.state.offerSortBy.column == 'routeId' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'routeId' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div>
                        <div className="cell wide pointer" onClick={()=>this.onOfferSortClick('routeComment')}>
                            מסלול 
                            {
                                this.state.offerSortBy.column == 'routeComment' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'routeComment' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div>
                        <div className="cell pointer" onClick={()=>this.onOfferSortClick('insuranceLabel')}>
                            סוג ביטוח
                            {
                                this.state.offerSortBy.column == 'insuranceLabel' ? (
                                <div className={`icon sort ${
                                    this.state.offerSortBy && this.state.offerSortBy.column == 'insuranceLabel' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                  }`}></div>
                                ) : (<></>)
                            }
                        </div> */}
                                        <div className="cell-price-pointer">
                                            מיגון
                                            
                                        </div>
                                        <div className="cell-price-pointer" onClick={() => this.onOfferSortClick('compulsoryPremium')}>
                                            חובה
                                            {
                                                this.state.offerSortBy.column == 'compulsoryPremium' ? (
                                                    <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'compulsoryPremium' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                        }`}></div>
                                                ) : (<></>)
                                            }
                                        </div>
                                        <div className="cell-price-pointer" onClick={() => this.onOfferSortClick('cascoPremium')}>
                                            קסקו
                                            {
                                                this.state.offerSortBy.column == 'cascoPremium' ? (
                                                    <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'cascoPremium' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                        }`}></div>
                                                ) : (<></>)
                                            }
                                        </div>
                                        <div className="cell-price-pointer" onClick={() => this.onOfferSortClick('ridersSum')}>
                                            חבילות
                                            {
                                                this.state.offerSortBy.column == 'ridersSum' ? (
                                                    <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'ridersSum' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                        }`}></div>
                                                ) : (<></>)
                                            }
                                        </div>
                                        <div className="cell-price-pointer" onClick={() => this.onOfferSortClick('totalSum')}>
                                            סה"כ
                                            {
                                                this.state.offerSortBy.column == 'totalSum' ? (
                                                    <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'totalSum' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                        }`}></div>
                                                ) : (<></>)
                                            }
                                        </div>
                                        <div className="cell offer-button-cell actions">

                                        </div>
                                    </div>
                                    {this.state.offersList && this.state.offersList != null && this.state.OpenProduction!=null ? this.state.offersList.map((offer: SimulatorOfferModel, index: number) => {
                                        return (
                                            <>
                                            
                                                <LeadOffer
                                                    offer={offer}
                                                    getAuthorizedToDriveName={this.props.getAuthorizedToDriveName}
                                                    key={index}
                                                    emailAddress={this.props.lead && this.props.lead.lead && this.props.lead.lead.email ? this.props.lead.lead.email : ''}
                                                    onRefreshData={() => this.onRefreshData()}
                                                    openPopupMessage={(d: any) => this.openPopupMessage(d)}
                                                    leadId={this.state.lead.id}
                                                    OpenProduction={(this.state.OpenProduction!=null ? this.state.OpenProduction:"")as string}
                                                    // onProductionClick={this.openProduction}
                                                ></LeadOffer>
                                            </>
                                        )
                                    }) : ""}

                                </div>
                                
                                    <LeadTreatments lead={this.props.lead}  />
                            </div>
                        </div>
                    ) : (
                        <p>No lead</p>
                    )}
                </div>
            </>



        );
    }
}


const mapDispatchToProps = (dispatch: any) => {
    return {
      dispatch,
      setPhoneNumberOfLead: (data: string) => dispatch(setPhoneNumberOfLead(data)),
    }
  }

  const mapStateToProps = (state: RootState) => ({
    phoneNumberOfLead: state.leads.phoneNumberOfLead,
  });

  export default connect(mapStateToProps, mapDispatchToProps)(OpenLead);
  